module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ux","ReactTransitionGroup"],"commonjs":["react-transition-group","default"],"commonjs2":["react-transition-group","default"],"amd":"react-transition-group"}
// module id = 15
// module chunks = 0